import { Link } from 'react-router-dom';
import './BuySell.css';
import { FaSearch, FaFileSignature, FaMoneyCheckAlt, FaHandHoldingUsd, FaChartLine, FaShieldAlt, FaUsers, FaClipboardCheck } from 'react-icons/fa';

export default function BuySell() {
  const buyingServices = [
    {
      icon: <FaSearch />,
      title: 'Property Search',
      description: 'Access to exclusive listings and personalized property recommendations based on your requirements.'
    },
    {
      icon: <FaChartLine />,
      title: 'Market Analysis',
      description: 'Comprehensive market research and property valuation to ensure you get the best deal.'
    },
    {
      icon: <FaFileSignature />,
      title: 'Documentation Support',
      description: 'Complete assistance with legal documentation, verification, and registration processes.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Legal Verification',
      description: 'Thorough title verification and legal clearance to ensure safe property transactions.'
    }
  ];

  const sellingServices = [
    {
      icon: <FaMoneyCheckAlt />,
      title: 'Property Valuation',
      description: 'Accurate property pricing based on current market trends and comparable sales data.'
    },
    {
      icon: <FaUsers />,
      title: 'Buyer Sourcing',
      description: 'Access to our extensive network of verified buyers actively looking for properties.'
    },
    {
      icon: <FaHandHoldingUsd />,
      title: 'Negotiation Support',
      description: 'Expert negotiation to get you the best price and favorable terms for your property.'
    },
    {
      icon: <FaClipboardCheck />,
      title: 'Transaction Management',
      description: 'End-to-end transaction coordination from listing to final handover and registration.'
    }
  ];

  const processSteps = [
    {
      number: '01',
      title: 'Initial Consultation',
      description: 'We understand your requirements, budget, and preferences in detail.'
    },
    {
      number: '02',
      title: 'Property Selection',
      description: 'Curated property options matching your criteria with site visits arranged.'
    },
    {
      number: '03',
      title: 'Documentation & Legal',
      description: 'Complete verification, paperwork, and legal clearance handled professionally.'
    },
    {
      number: '04',
      title: 'Transaction Closure',
      description: 'Smooth transaction completion with registration and handover assistance.'
    }
  ];

  return (
    <>
      <section className="buysell-hero">
        <div className="buysell-hero-content">
          <h1>Buy & Sell Properties</h1>
          <p>Your trusted partner for seamless property transactions</p>
        </div>
      </section>

      <section className="buysell-intro">
        <div className="buysell-container">
          <div className="intro-content">
            <h2>Expert Property Transaction Services</h2>
            <p>
              Whether you're looking to buy your dream property or sell your current one, we provide comprehensive 
              services to make your transaction smooth, secure, and successful. Our experienced team guides you 
              through every step of the process with transparency and professionalism.
            </p>
          </div>
        </div>
      </section>

      <section className="services-section buying-services">
        <div className="buysell-container">
          <h2 className="section-title">Buying Services</h2>
          <div className="services-grid">
            {buyingServices.map((service, index) => (
              <div key={index} className="service-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-section selling-services">
        <div className="buysell-container">
          <h2 className="section-title">Selling Services</h2>
          <div className="services-grid">
            {sellingServices.map((service, index) => (
              <div key={index} className="service-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="process-section">
        <div className="buysell-container">
          <h2 className="section-title">Our Process</h2>
          <div className="process-steps">
            {processSteps.map((step, index) => (
              <div key={index} className="process-step" style={{ animationDelay: `${index * 0.15}s` }}>
                <div className="step-number">{step.number}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-choose-section">
        <div className="buysell-container">
          <div className="why-choose-wrapper">
            <div className="why-choose-image">
              <img 
                src="https://images.pexels.com/photos/1370704/pexels-photo-1370704.jpeg?auto=compress&cs=tinysrgb&w=800" 
                alt="Property Transaction" 
              />
            </div>
            <div className="why-choose-content">
              <h2>Why Choose Our Services?</h2>
              <ul className="benefits-list">
                <li>Extensive portfolio of verified properties</li>
                <li>Transparent pricing with no hidden charges</li>
                <li>Expert legal and documentation support</li>
                <li>Dedicated relationship manager for each client</li>
                <li>Quick transaction closure with complete assistance</li>
                <li>Post-sale support and guidance</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="buysell-cta">
        <div className="buysell-container">
          <div className="cta-content">
            <h2>Ready to Buy or Sell Your Property?</h2>
            <p>Connect with our property experts for a free consultation</p>
            <Link to="/contact" className="cta-button">
              Get Started Today
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
